import { Box, Typography, Rating } from '@mui/material';
import theme from '../../theme';

const RatingReadOnly = ({ value, variant = 'default', sx = {} }) => {
  const sizes = {
    responsive: {
      rating: { xs: 12, md: 14 },
      typo: { xs: 12, md: 14 },
    },
    small: {
      rating: 12,
      typo: 12,
    },
    default: {
      rating: 14,
      typo: 14,
    },
    iconfix: {
      rating: 14,
      typo: { xs: 13, md: 14 },
    },
    typofix: {
      rating: { xs: 12, md: 14 },
      typo: 14,
    },
    fullResponsive: {
      rating: { xs: 12, md: 14, lg: 14 },
      typo: { xs: 12, md: 13, lg: 14 },
    },
    fullResponsiveCompact: {
      rating: { xs: 12, md: 14, lg: 12 },
      typo: { xs: 12, md: 13, lg: 12 },
    },
  };

  const currentSizes = sizes[variant] || sizes.default;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
      <Rating
        readOnly
        value={value}
        precision={0.5}
        sx={{
          fontSize: currentSizes.rating,
          color: theme.palette.secondary.main,
        }}
      />
      <Typography
        variant="body3"
        color={theme.palette.black[4]}
        sx={{
          ml: 0.5,
          fontSize: currentSizes.typo,
        }}
      >
        ({(value || 0).toFixed(1)})
      </Typography>
    </Box>
  );
};

export default RatingReadOnly;
